import React from 'react';
import { Breadcrumb } from 'antd';
import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Control.css';
import Footer from '../../Footer';
import { useTranslation } from 'react-i18next';

const Control = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
  const { t, i18n } = useTranslation();

  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView) {
      controls.start({ opacity: 1, y: 0 });
    }
  }, [controls, inView]);

  return (
    <motion.div ref={ref} animate={controls} initial={{ opacity: 0, y: 50 }}>
      <div className={`wrapper_CTL_pages ${isMobile ? 'mobile' : ''}`}>
        <Helmet>
          <title>{t("Professional Inspectors - Champ d'Activité")}</title>
          <meta
            name="description"
            content={t("Découvrez nos domaines d'activité. Plateforme maritime, réservoir de stockage, navire marin, appareils à pression, gazoduc, tubulaire de forage, centrale électrique, raffinerie, appareil de levage, installations électriques, installation de gaz. Services de contrôle et d'inspection par Professional Inspectors.")}
          />
          <meta
            name="keywords"
            content={t("Champ d'activité, Plateforme maritime, Réservoir de stockage, Navire marin, Appareils à pression, Gazoduc, Tubulaire de forage, Centrale électrique, Raffinerie, Appareil de levage, Installations électriques, Installation de gaz, Professional Inspectors")}
          />
        </Helmet>
        <div className="container_15">
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="/">{t('Accueil')}</Breadcrumb.Item>
            <Breadcrumb.Item>{t("Champ d'activité")}</Breadcrumb.Item>
          </Breadcrumb>
          <div className="row">
            <div className="pic service_cover">
              <img src="images/CA.jpg" className="img-fluid intro_image" alt={t("Champ d'activité")} />
            </div>
            <motion.div className={`col-sm-6 strategic CA ${isMobile ? 'mobile' : ''}`} animate={controls}>
              <h3>{t('CHAMP D\'ACTIVITE')}</h3>
              <ul>
                <li>{t('Plateforme maritime')}</li>
                <li>{t('Réservoir de stockage')}</li>
                <li>{t('Navire marin')}</li>
                <li>{t('Appareils à pression')}</li>
                <li>{t('Gazoduc')}</li>
                <li>{t('Tubulaire de forage')}</li>
                <li>{t('Centrale électrique')}</li>
                <li>{t('Raffinerie')}</li>
                <li>{t('Appareil de levage')}</li>
                <li>{t('Installations électriques')}</li>
                <li>{t('Installation de gaz')}</li>
              </ul>
            </motion.div>
          </div>
        </div>
        <Footer />
      </div>
    </motion.div>
  );
};

export default Control;
